// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORM_IS_DIRTY_ARE_YOU_SURE_YOU_WANT_TO_LEAVE = "Ur\u010dit\u011b chce\u0161 odej\u00edt? P\u0159ijde\u0161 o neulo\u017een\u00e9 zm\u011bny.";
export const TOAST_ERRORS_IN_FORM = "Formul\u00e1\u0159 se nepoda\u0159ilo odeslat. N\u011bkde v n\u011bm m\u00e1\u0161 chybu.";
